import { docEntityBaseNew } from "building-types/entities/docEntityBaseNew";
import type { PlanSetTemplateConfig } from "./planSets";

export function planSetTemplateConfigNew(props: Partial<PlanSetTemplateConfig>): PlanSetTemplateConfig {
  return {
    ...docEntityBaseNew("PLAN_SET_TEMPLATE_CONFIG"),
    ...props,
    parameterValues: {},
    globalParameterValues: {},
  };
}
